import React from 'react';
import BaseToolbarFeature from './base-toolbar-feature';
import EffectMenu from '@com/tool-bar/menu/effect-menu';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { IActionPointInfo } from '@tencent/workbench';
import { wrapIdForPic, wrapIdForTextTab } from '../../util/wrap-id-util';
import { PresetElementType } from '../../const/preset-element-type';

/**
 * 网格面板，用于项目符号、数字符号等
 */
export default class BaseGridFeature extends BaseToolbarFeature {
    public constructor() {
        super();
    }

    /**
     * 获取默认的样式
     * @param dropdown
     */
    public getDefaultStyle(dropdown) {
        dropdown.itemWidth = 32;
        dropdown.itemHeight = 32;
        dropdown.itemPadding = 4;
        dropdown.showBorder = false;
    }

    // todo: 同上，拆到每个类型下
    public handleMenuClick = (index) => {
        const { dropdown } = this.config;
        if (!dropdown) return;
        const itemData = dropdown.data[index];
        this.callback(itemData.id);
    };

    /**
     * 下拉展示的获取网格面板
     */
    public showContent(info: IActionPointInfo, useStyle: boolean) {
        const { dropdown } = this.config;
        if (!dropdown) return <div />;
        this.getDefaultStyle(dropdown);
        const { checkSelectedValue } = dropdown;
        const style = useStyle ? {
            background: 'hsla(0, 0%, 100%)',
            transform: 'scaleX(1) translate(0)',
            padding: '8px 0',
            border: '1px solid rgba(0, 0, 0, 0.12)',
            borderRadius: '4px',
        } : {};
        const presetElementType = this.getPresetElementType(info);
        return (<div style={style}>
            <EffectMenu
                {...dropdown}
                callbackByActionType={this.callbackByActionType.bind(this)}
                presetElementType={presetElementType}
                checkSelectedValue={checkSelectedValue}
                id={this.id}
                hideMenu={() => {}}
                handleClick={(actionType, obj) => {
                    this.callbackByActionType(actionType, obj);
                }}
                onMenuClick={this.handleMenuClick}
                rightSideBarManager={this.getAppService().editableServiceLayer?.rightSideBarManager}
                selectionService={this.getSelectionService()}
                menuManager={this.getMenuManager()}
                showPresetMenu={true}
                showMore={true}
                checkSelectType={this.checkSelectType}
                previewService={this.getAppService().editableServiceLayer?.previewService}
                themeColorManager={this.getAppService().editableServiceLayer?.themeColorManager}
            />
        </div>);
    }

    private getPresetElementType(info: IActionPointInfo) {
        const { name } = info;
        return name === wrapIdForPic(this.config.id)
            ? PresetElementType.IMAGE
            : name === wrapIdForTextTab(this.config.id)
                ? PresetElementType.TEXT
                : PresetElementType.SHAPE;
    }
}
